var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.667A13.333 13.333 0 0 0 2.666 16a13.187 13.187 0 0 0 3.014 8.44l-2.667 2.667a1.333 1.333 0 0 0-.28 1.453A1.334 1.334 0 0 0 4 29.334h12a13.333 13.333 0 0 0 0-26.667Zm0 24H7.213l1.24-1.24a1.333 1.333 0 0 0 0-1.88A10.667 10.667 0 1 1 16 26.667Z",
    fill: "#fff"
  })));
};
export default SvgMessage;